import { render, staticRenderFns } from "./AnimatedText.vue?vue&type=template&id=c5279c42&scoped=true&"
import script from "./AnimatedText.vue?vue&type=script&lang=js&"
export * from "./AnimatedText.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedText.vue?vue&type=style&index=0&id=c5279c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5279c42",
  null
  
)

export default component.exports